module.exports = __webpack_public_path__ + "img/p-13-2.92a0fd6e.jpg";